import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";

interface _Props {
    userRepository: UserRepository;
}
@injectable()
export default class DeleteUserUseCase {
    private userRepository: UserRepository;
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    public call = async (id: string) : Promise<Either<ErrorEntity, void>> => {
        return this.userRepository.deleteUser(id);
    }
}

export const DeleteUserUseCaseName = "DeleteUserUseCase";